<template>
  <div class="app-wrapper">
    <!-- ADMIN GUMB GORE DESNO -->
    <div class="admin-bar">
      <router-link v-if="isLoggedIn" to="/Signout" class="admin-button"
        >Odjava</router-link
      >
      <router-link v-else to="/Login" class="admin-button">Admin</router-link>
    </div>

    <!-- NASLOV NA PERGAMENTU -->
    <div class="header-banner">
      <h1 class="site-title">
        <router-link to="/">Tekstovi izvorne muzike</router-link>
      </h1>
    </div>

    <!-- NAV + SEARCH + ABECEDA -->
    <div class="nav-wrapper">
      <nav class="main-nav">
        <router-link to="/" class="nav-btn">Svi tekstovi</router-link>
        <router-link to="/oNama" class="nav-btn">O nama</router-link>
        <router-link to="/kontakt" class="nav-btn">Kontakt</router-link>
        <router-link v-if="isLoggedIn" to="/import" class="nav-btn"
          >Dodaj pjesme</router-link
        >

        <div
          class="search-box"
          @focusin="showDropdown = true"
          @focusout="hideDropdownWithDelay"
        >
          <input
            type="text"
            v-model="searchQuery"
            @input="onSearchInput"
            @keydown.enter.prevent="handleEnter"
            placeholder="Pretraži..."
          />
          <button @click="goToSearchResults">
            <i class="fas fa-search"></i>
          </button>

          <!-- Dropdown prijedlozi -->
          <ul
            v-if="showDropdown && filteredItems.length"
            class="dropdown-results"
          >
            <li
              v-for="(item, index) in filteredItems"
              :key="index"
              @mousedown.prevent="navigateToRoute(item)"
            >
              {{
                item.type === "song"
                  ? item.song + " — " + item.singer
                  : item.name
              }}
            </li>
          </ul>
        </div>
      </nav>

      <!-- Abeceda -->
      <div class="alphabet-navbar">
        <router-link to="/0-9" class="alphabet-card">0-9</router-link>
        <router-link
          v-for="letter in alphabet"
          :key="letter"
          :to="'/stranice/' + letter"
          class="alphabet-card"
        >
          {{ letter }}
        </router-link>
      </div>
    </div>

    <router-view />
    <!-- FOOTER -->
    <footer class="app-footer">
      <p>
        Prijatelji stranice:
        <a href="https://radiospreca.com" target="_blank">Radio Spreča</a>,
        <a href="https://dobravoda-radio.jimdofree.com/" target="_blank"
          >Radio Dobra Voda</a
        >,
        <a href="https://www.koprivljanskiradio.com" target="_blank"
          >Koprivljanski radio</a
        >
      </p>
    </footer>
  </div>
</template>

<script>
import { auth, db } from "@/firebase.js";
import { collection, getDocs } from "firebase/firestore";
import "@fortawesome/fontawesome-free/css/all.css";

export default {
  data() {
    return {
      isLoggedIn: false,
      searchQuery: "",
      showDropdown: false,
      items: [],
      filteredItems: [],
      dropdownTimeout: null,
      filterTimeout: null,
      alphabet: [
        "A",
        "B",
        "C",
        "Č",
        "Ć",
        "D",
        "Đ",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "R",
        "S",
        "Š",
        "T",
        "U",
        "V",
        "Y",
        "Z",
        "Ž",
      ],
    };
  },
  created() {
    auth.onAuthStateChanged((user) => {
      this.isLoggedIn = !!user;
    });

    this.fetchItems();
  },
  beforeUnmount() {
    clearTimeout(this.dropdownTimeout);
    clearTimeout(this.filterTimeout);
  },
  methods: {
    async fetchItems() {
      try {
        const cached = localStorage.getItem("songs_cache");
        const cachedAt = localStorage.getItem("songs_cache_at");
        const maxAgeMs = 6 * 60 * 60 * 1000; // 6h

        if (cached && cachedAt && Date.now() - Number(cachedAt) < maxAgeMs) {
          this.items = JSON.parse(cached);
          return;
        }

        const querySnapshot = await getDocs(collection(db, "songs"));
        const seen = new Set();
        const results = [];

        querySnapshot.forEach((doc) => {
          const data = doc.data();

          if (!seen.has(data.singerName)) {
            seen.add(data.singerName);
            results.push({ type: "singer", name: data.singerName });
          }

          const key = data.songName + "|" + data.singerName;
          if (!seen.has(key)) {
            seen.add(key);
            results.push({
              type: "song",
              name: `${data.songName} — ${data.singerName}`,
              song: data.songName,
              singer: data.singerName,
              lyrics: data.lyrics || "",
            });
          }
        });

        this.items = results;
        localStorage.setItem("songs_cache", JSON.stringify(results));
        localStorage.setItem("songs_cache_at", String(Date.now()));
      } catch (err) {
        console.error("Greška kod dohvaćanja pjesama:", err);
      }
    },

    filterItems() {
      this.filteredItems = [];
      this.showDropdown = false;

      const searchText = this.normalizeText(this.searchQuery);
      const uniqueKeys = new Set();

      if (!searchText) return;

      this.items.forEach((item) => {
        const labelRaw =
          item.type === "song" ? `${item.song} — ${item.singer}` : item.name;

        const labelNorm = this.normalizeText(labelRaw);

        const matchesLyrics =
          item.lyrics && this.normalizeText(item.lyrics).includes(searchText);

        const uniqueKey =
          item.type === "song"
            ? `song|${item.song}|${item.singer}`
            : `singer|${item.name}`;

        if (
          (labelNorm.includes(searchText) || matchesLyrics) &&
          !uniqueKeys.has(uniqueKey)
        ) {
          uniqueKeys.add(uniqueKey);
          this.filteredItems.push(item);
        }
      });

      this.showDropdown = this.filteredItems.length > 0;
    },

    onSearchInput() {
      clearTimeout(this.filterTimeout);
      this.filterTimeout = setTimeout(() => {
        this.filterItems();
      }, 150);
    },
    normalizeText(str) {
      return (str || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d")
        .replace(/-/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    },

    navigateToRoute(item) {
      this.showDropdown = false;

      const isSong = item.type === "song";
      const singer = isSong ? item.singer : item.name;

      const firstCharRaw = singer.trim().charAt(0);
      const firstCharNorm = this.normalizeText(firstCharRaw).toUpperCase();

      const letter = /^[0-9]/.test(firstCharNorm) ? "0-9" : firstCharNorm;

      const route = isSong
        ? `/stranice/${letter}/${encodeURIComponent(
            singer
          )}/${encodeURIComponent(item.song)}`
        : `/stranice/${letter}/${encodeURIComponent(singer)}`;

      this.$router.push(route).catch(() => {});
      this.searchQuery = "";
    },

    handleEnter() {
      const q = this.normalizeText(this.searchQuery);

      const exact = this.filteredItems.find((item) => {
        const labelRaw =
          item.type === "singer" ? item.name : `${item.song} — ${item.singer}`;

        return this.normalizeText(labelRaw) === q;
      });

      if (exact) {
        this.navigateToRoute(exact);
      } else {
        this.goToSearchResults();
      }
    },

    goToSearchResults() {
      const query = this.searchQuery.trim();
      if (query) {
        this.$router.push(`/search/${encodeURIComponent(query)}`);
        this.searchQuery = "";
        this.showDropdown = false;
      }
    },

    hideDropdownWithDelay() {
      this.dropdownTimeout = setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: "Monotype Corsiva", "Georgia", cursive;
  background-image: url("@/assets/violinbg.jpeg");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
  color: #2d0b00;
}

.app-wrapper {
  text-align: center;
}

/* ===== Admin button gore desno ===== */
.admin-bar {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
}

.admin-button {
  background-image: url("@/assets/bgperg.jpg");
  background-size: cover;
  border: 2px solid #804000;
  border-radius: 20px;
  padding: 6px 14px;
  font-weight: bold;
  font-family: "Monotype Corsiva", "Georgia", cursive;
  color: #2d0b00;
  text-decoration: none;
  text-shadow: 1px 1px 0 #d8b68a, -1px -1px 0 #fff1d0;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
  transition: transform 0.2s ease, filter 0.2s ease;
}

.admin-button:hover {
  filter: brightness(1.15);
  transform: scale(1.05);
}

/* ===== Naslov pergament ===== */
.header-banner {
  background-image: url("@/assets/bgperg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border: 2px solid #804000;
  padding: 25px;
  margin: 30px auto 10px;
  max-width: 700px;
  border-radius: 0 0 20px 20px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.6s ease forwards;
  opacity: 0;
}

.site-title {
  text-decoration: none;
  color: inherit;
  font-size: 48px;
  font-weight: bold;
  margin: 0;
  color: #2d0b00;
  text-shadow: 2px 2px 0 #fff1d0, -1px -1px 0 #804000;
}

.site-title a {
  text-decoration: none;
  color: inherit;
}

.site-title a:hover {
  opacity: 0.8;
  text-decoration: none;
}

/* ===== Navigacijska kutija ===== */
.nav-wrapper {
  margin: 20px auto;
  padding: 30px 20px;
  background-image: url("@/assets/bgperg.jpg");
  background-size: cover;
  background-position: center;
  border: 2px solid #804000;
  border-radius: 20px;
  max-width: 1000px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.6s ease 0.2s forwards;
  opacity: 0;
}

/* ===== Navigacijski gumbi ===== */
.main-nav {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
}

/* Gumbi (nav, admin, search, alphabet) */
.nav-btn,
.admin-button,
.alphabet-card,
.search-box {
  font-size: 24px;
  background-image: url("@/assets/bgperg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border: 2px solid #804000;
  border-radius: 20px;
  padding: 6px 14px;
  font-weight: bold;
  font-family: "Monotype Corsiva", "Georgia", cursive;
  color: #2d0b00;
  text-decoration: none;
  text-shadow: 1px 1px 0 #d8b68a, -1px -1px 0 #fff1d0;
  transition: transform 0.2s ease, filter 0.2s ease;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

/* Hover efekt za sve gumbe */
.nav-btn:hover,
.admin-button:hover,
.alphabet-card:hover,
.search-box:hover {
  filter: brightness(1.15);
  transform: scale(1.05);
  cursor: pointer;
}

/* Klik animacija */
.nav-btn:active,
.admin-button:active,
.alphabet-card:active,
.search-box:active {
  transform: scale(0.98);
  filter: brightness(0.9);
}

/* ===== Tražilica ===== */
.search-box {
  position: relative;
  display: flex;
  align-items: center;
  background-image: url("@/assets/bgperg.jpg");
  background-size: cover;
  border: 2px solid #804000;
  border-radius: 20px;
  padding: 4px 10px;
}

.search-box input {
  border: none;
  background: transparent;
  outline: none;
  padding: 4px;
  font-size: 24px;
  width: 100px;
  color: #2d0b00;
  font-family: "Monotype Corsiva", "Georgia", cursive;
}

.search-box button {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #2d0b00;
}

/* ===== Abeceda ===== */
.alphabet-navbar {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
}

.alphabet-card {
  display: inline-block;
  padding: 6px 12px;
  font-size: 24px;
  font-weight: bold;
  border: 2px dashed #804000;
  border-radius: 12px;
  text-decoration: none;
}

/* ===== Animacije ===== */
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}
.search-dropdown {
  position: absolute;
  background-color: rgba(255, 248, 235, 0.95);
  border: 2px solid #804000;
  border-top: none;
  border-radius: 0 0 12px 12px;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 220px;
  z-index: 100;
  font-family: "Times New Roman", Times, serif;
}

.dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px dashed #c7a97d;
  background-color: transparent;
}

.dropdown-item:hover {
  background-color: #fff0dc;
}
.dropdown-results {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background-color: rgba(255, 248, 235, 0.95);
  border: 2px solid #804000;
  border-radius: 10px;
  list-style: none;
  margin-top: 5px;
  padding: 6px 0;
  z-index: 99;
  max-height: 200px;
  overflow-y: auto;
  font-family: "Times New Roman", Times, serif;
}

.dropdown-results li {
  padding: 6px 12px;
  cursor: pointer;
  font-size: 18px;
  text-align: left;
}

.dropdown-results li:hover {
  background-color: #ffe8d0;
}
.app-footer {
  margin-top: 40px;
  padding: 15px 20px;
  text-align: center;
  font-family: "Monotype Corsiva", "Georgia", cursive;
  font-size: 18px;
  background-color: rgba(255, 248, 235, 0.7);
  border-top: 2px solid #804000;
  border-radius: 20px 20px 0 0;
  color: #2d0b00;
  backdrop-filter: blur(2px);
}

.app-footer a {
  color: #2d0b00;
  font-weight: bold;
  text-decoration: none;
  margin: 0 6px;
}

.app-footer a:hover {
  text-decoration: underline;
  color: #5a3e1b;
}
</style>
